import { isFunction, isObject } from 'lodash'
import { FilterStateSet } from 'types'

// See this https://gist.github.com/dai-shi/4950506 for info startsWith search benchmarks
export const startsWithFilter = (key: string, value: any) => (datum: any) =>
  String(datum[key]).toLowerCase().lastIndexOf(value.toLowerCase(), 0) === 0
export const exactMatchFilter = (key: string, value: any) => (datum: any) =>
  String(datum[key]).toLowerCase() === value.toLowerCase()

class ColumnFilter {
  // Choose the appropriate filter type.
  static selectFilter(filterType: any) {
    switch (filterType) {
      case 'text':
        return startsWithFilter
      case 'exact':
        return exactMatchFilter
      default:
        throw new Error(`filterType must be either "text" or "exact". If you need some other type of filtering,
         please implement a custom filter.`)
    }
  }

  // TODO: kill this "any"
  static filterRows(filterData: FilterStateSet = {}, rows: any) {
    let filteredRows = rows
    const filters = Object.entries(filterData)
      .map((entry) => {
        let filter = null
        const key = entry[0]
        const obj = entry[1]
        if (isObject(obj) && isFunction(obj.filter) && 'value' in obj) {
          const valStr = String(obj.value)
          if (valStr.length > 0) {
            filter = obj.filter(key, valStr)
          }
        }
        return filter
      })
      .filter(Boolean)
    // apply filters to rows
    if (filters.length) {
      filteredRows = filters.reduce(
        (results, filter) => results.filter(filter),
        rows
      )
    }
    return filteredRows
  }
}

export default ColumnFilter
